module.exports = __webpack_public_path__ + "static/media/24UHCHR2.0b1664d3.jpg";